import { css } from '@emotion/react'
import { mq } from 'plume-ui'

type Props = {
  id: string
  children?: React.ReactNode
}

export const EmptyOffsetAnchor: React.FC<Props> = (props) => {
  return (
    <div
      css={css`
        #${props.id} {
          display: hidden;
          position: relative;
          // navbar height - padding height + divider height
          top: calc(-128px + 1px);
          right: 0;
          ${mq.untilMedium} {
            top: calc(-55px - 40px + 1px);
          }
        }
      `}
    >
      <div id={props.id} />
      {props.children}
    </div>
  )
}
